var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-treeview", {
    staticClass: "v-card__text pa-0",
    staticStyle: { width: "max-content" },
    attrs: {
      items: _vm.items,
      "load-children": _vm.getChildren,
      activatable: "",
      active: _vm.computedValue,
      open: _vm.open,
      "return-object": "",
      dense: "",
    },
    on: {
      "update:active": function ($event) {
        _vm.computedValue = $event
      },
      "update:open": function ($event) {
        _vm.open = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "prepend",
        fn: function (ref) {
          var item = ref.item
          var open = ref.open
          return [
            item._type === "folder"
              ? _c("v-icon", [
                  _vm._v(
                    " " + _vm._s(open ? "mdi-folder-open" : "mdi-folder") + " "
                  ),
                ])
              : _c("v-icon", [_vm._v(" mdi-file-document-outline ")]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }